import { register } from 'async-ops';
import { callMdaePublicApi } from "../../../call-web-api";
import { getDefaultOptions, throwExceptionErrors } from '../../../utils/fetch';

export const GET_UNSEEN_DOCUMENT_COUNT = 'GET_UNSEEN_DOCUMENT_COUNT';

export const service = async (data) => {
  const response: any = await callMdaePublicApi({
      url: '/Api/Document/GetUnseenDocumentCount',
      type: "POST",
      contentType: 'application/json',
      isRoutedApiCall: true,
      ...getDefaultOptions(),
      body: JSON.stringify({
        attachedLevelId: data.attachedLevelId,
        attachedLevelName: data.attachedLevelName
      })
  })
  throwExceptionErrors(response);
  return response;

};

const mockData = () => {
  return ([])
};

const mock = () => Promise.resolve(mockData());

register(GET_UNSEEN_DOCUMENT_COUNT, service, mock);
